import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rubro_id: null,
            pais_id: null,
            clasificacion_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            rubro_id: data.rubro_id,
            pais_id: data.pais_id,
            clasificacion_id: data.clasificacion_id,
        });
    }
    render() {
        return (
            <ParadigmaModal
                getUrl={api.clientes.empresas.delete}
                postUrl={api.clientes.empresas.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Empresa ha sido eliminada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Empresa"}
                buttonTitle={"Eliminar Empresa"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-4 col-md-3">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Razón Social</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="razonSocial" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>CUIT</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="cuit" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Clasificación</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"clasificacion_id"} value={this.state.clasificacion_id} url={api.clientes.clasificacion.select} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Rubro</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"rubro_id"} value={this.state.rubro_id} url={api.clientes.rubros.select} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="email" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="telefono" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>País</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"pais_id"} url={api.misc.paises.select} value={this.state.pais_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observaciones" disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/clientes/Empresas/Delete.js